<template>
    <b-modal size="lg" :no-close-on-backdrop="true" :title="Core.Definition.getDefinition('Aperçu')" :hide-footer="true" v-model="dataShow">
        <Request
                ref="request"
                root="/form-template/preview"
                :onRequestSuccess="onRequestSuccess">
            <slot slot="body">
                <iframe style="width: 100%; height: 600px" id="formTemplatePreview" name="formTemplatePreview" ref="formTemplatePreview"></iframe>
            </slot>
        </Request>

    </b-modal>
</template>

<script>
    import Request from './Request'
    export default {
        name: 'ModalFormTemplatePreview',
        components: {
            Request
        },
        props: {
        },
        computed: {
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataShow: false,
                dataTitle: '',
                dataFormTemplateId: 0,
                dataBinderFormId: 0,
            }
        },
        methods: {
            open(formTemplateId, binderFormId) {
                this.dataShow = true
                this.dataFormTemplateId = formTemplateId
                this.dataBinderFormId = binderFormId

                this.$nextTick(() => {
                    this.$refs.request.addArg('formTemplateId', this.dataFormTemplateId)
                    this.$refs.request.addArg('binderFormId', this.dataBinderFormId)
                    this.$refs.request.request()
                })
            },
            onInit() {
            },
            onRequestSuccess(data, method) {
                if(data.html !== undefined) {
                    document.getElementById('formTemplatePreview').src = "data:text/html;charset=iso-8859-1," + escape(data.html);
                }
            },
            print() {
                var newWin = document.getElementById('formTemplatePreview').contentWindow;
                newWin.document.write(body);
                newWin.document.close(); //important!
                newWin.focus(); //IE fix
                newWin.print();
            }
        }
    }
</script>
